import React, {useEffect,useState} from 'react';
import axios from 'axios';

export default function PasswordGate({children}) {
  const [allowed,setAllowed]=useState(null);
  const [password,setPassword]=useState('');
  const [error,setError]=useState('');
  const [busy,setBusy]=useState(false);
  useEffect(()=>{axios.get('/api/auth/me').then(r=>setAllowed(!!r.data.authenticated)).catch(()=>setAllowed(false));},[]);
  const login=async(e)=>{
    e.preventDefault();setBusy(true);setError('');
    try {await axios.post('/api/auth/login',{password});setAllowed(true);setPassword('');}
    catch(err){setError(err.response?.data?.detail||'Accesso non riuscito');}
    finally{setBusy(false);}
  };
  if(allowed===null)return <div style={{padding:40,textAlign:'center'}}>Verifica accesso…</div>;
  if(allowed)return children;
  return <main style={{minHeight:'100vh',display:'grid',placeItems:'center',background:'#f6f6f3'}}>
    <form onSubmit={login} style={{background:'white',padding:32,borderRadius:12,width:'min(400px,90vw)',boxShadow:'0 8px 30px #0001'}}>
      <h1 style={{fontSize:24,fontWeight:700,marginBottom:8}}>EasyHost Marketing</h1>
      <p style={{marginBottom:20}}>Pannello riservato</p>
      <label htmlFor="panel-password">Password</label>
      <input id="panel-password" type="password" autoComplete="current-password" value={password} onChange={e=>setPassword(e.target.value)} required style={{display:'block',width:'100%',padding:12,margin:'8px 0 16px',border:'1px solid #aaa',borderRadius:6}}/>
      {error&&<p role="alert" style={{color:'#a22'}}>{error}</p>}
      <button disabled={busy} type="submit" style={{width:'100%',background:'#2A4B3C',color:'white',padding:12,border:0,borderRadius:6}}>{busy?'Accesso…':'Accedi'}</button>
    </form>
  </main>;
}
